import PropTypes from 'prop-types';
import React from 'react';

const ChairRentalPaymentRefundButton = ({ refund }) => (
  <div>
    <button
      type="button"
      className="c-btn c-btn--outline c-btn--outline-grey c-btn--small ignore-react-onclickoutside"
      onClick={refund}
    >
      Refund
    </button>
  </div>
);

ChairRentalPaymentRefundButton.propTypes = {
  refund: PropTypes.func.isRequired,
};

export default ChairRentalPaymentRefundButton;
